/** controller for login.html **/
(function () {

    SUGApp.controller('authenticationController',
                ['$scope','$uibModalInstance','authenticationService','SUGUtilities','facebookService','$location','loginRequired','loginMessage','register','registerDisabled','$sce','$timeout','commonRegExService', '$window',
                function( l, m, svc, util, fbSvc, $location, loginRequired, loginMessage, register, registerDisabled, sce, $timeout, commonRegExService, $window ){

        l.processing = false;
        l.complete = false;
        l.message = '';
        l.register = false;
        l.registerDisabled = ( angular.isDefined(registerDisabled) && registerDisabled ) ? true : false;
        l.frm = {};
        l.frm.loginemail = '';
        l.frm.newemail = '';
        l.frm.pword = '';
        l.frm.remember = false;
        l.frm.firstname = '';
        l.frm.lastname = '';
        l.frm.companyname = '';
        l.frm.show = 'login';
        l.frm.verifytype = 'existing';
        l.errorMessages = {};
        l.hasErrors = false;
        l.btnLabel = 'Login';
        l.mainLabel = "SignUpGenius Login";
        l.blacklistedAddress = '';
        l.fbAuth = false;
        l.fbBtnLabel = 'Login with Facebook';
        l.sugAccountRequired = loginRequired;
        l.loginMessage = loginMessage;
        l.captcha = '';
        l.captchaValid = false;
        l.showrecaptcha = false;
        l.failedlogins = 0;
		l.passwordmustbechanged = false;
		l.passwordRules = [];
        l.hideForgotPassword = false;

		util.getReCaptcha({})
			.then( function(response){
				var r = util.lowerCaseKeys( response );
				if( !resultCheck( r.data ) ){
					// captcha fail
				} else {
					l.captcha = sce.trustAsHtml( r.data.data.snippet );
					l.recaptchafeature =  r.data.data.feature;
				}
			});
		svc.getLoginRateLimit({})
			.then( function(response){
				var r = util.lowerCaseKeys( response );
				if( !resultCheck( r.data ) ){
					// fail
				} else {
					l.ratelimit = r.data.data;
				}
			});
		svc.passwordRulesText({})
			.then( function(response){
				var r = util.lowerCaseKeys( response );
				if( !resultCheck( r.data ) ){
					// fail
				} else {
					l.passwordRules = r.data.message;
				}
			});

        /** method for switching between forms **/
        l.showForm = function( thisForm ){
            l.frm.show = thisForm;
            l.errorMessages = {};
            l.hasErrors = false;
            l.complete = false;
            // Clear out form fields when changing forms
            l.frm.loginemail = '';
            l.frm.newemail = '';
            l.frm.pword = '';
            l.frm.firstname = '';
            l.frm.lastname = '';
            if( thisForm == 'login' ){
                l.mainLabel = "SignUpGenius Login";
                l.btnLabel = 'Login';
            } else if(thisForm == 'register'  ){
                l.mainLabel = "Account Registration";
                l.btnLabel = 'Register Now';
            }
            else if(thisForm == 'blacklisted'  ){
                l.mainLabel = 'Account Login Disabled';
                l.btnLabel = 'Send Link';
            }
            else {
                l.mainLabel = "Forgot Your Password?";
                l.btnLabel = 'Submit';
            }
        };

        /** processing forgot password **/
        l.forgotPassword = function(){
            validateForm();
            if( l.hasErrors )
                return;

            l.message = '';
            var oldBtn = l.btnLabel;
            l.processing = true;
            l.btnLabel = 'Processing...';
            var data = {};
                data.email = l.frm.loginemail;
            svc.forgotPassword( data )
                .then(function( response ){
                    var r = util.lowerCaseKeys( response );
                    if( !resultCheck( r.data ) ){
                        errorHandler( r.data );
                    }
                    else {
                        l.complete = true;
                        l.message = sce.trustAsHtml(r.data.message);
                        l.hideForgotPassword = true;
                    }
                    l.processing = false;
                    l.btnLabel = oldBtn;
                });

        };


        /** login user **/
        l.loginUser = function(){
            validateForm();
            if( l.hasErrors ) {
                return;
            }

            l.message = '';
            var oldBtn = l.btnLabel;
            l.processing = true;
            l.btnLabel = 'Processing...';
            var data = {};
            data.email = l.frm.loginemail;
            data.password = l.frm.pword;
			if( l.frm.remember ) {
				data.remember = l.frm.remember;
			}
            svc.loginUser( data )
                .then(function( response ){
                    var r = util.lowerCaseKeys( response );
                    if( !resultCheck( r.data ) ){
                        var d = 'data' in r.data ? r.data.data : {};
                        if( angular.isDefined(d.isblacklisted) && d.isblacklisted ){
                            l.processing = false;
                            l.btnLabel = oldBtn;
                            l.blacklistedAddress = l.frm.loginemail;
                            l.frm.pword = '';
                            l.showForm( 'blacklisted' );
                        } else {
                            // Handle failed logins
							l.failedlogins = r.data.data.failed;
                            l.ipfailedlogins = r.data.data.recaptcha.count;
							l.showrecaptcha = l.recaptchafeature.enabled && (l.failedlogins >= l.recaptchafeature.displayafter_attempts || l.ipfailedlogins >=  r.data.data.recaptcha.limit) ? true : false;
                            errorHandler( r.data );
                            l.processing = false;
                            l.btnLabel = oldBtn;
                        }
                    }
                    else {
                        var resp = {};
                        resp.data = r.data.data;

                        resp.status = 'loggedin';
                        l.failedlogins = 0;
                        l.showrecaptcha = false;
                        l.passwordmustbechanged = resp.data.passwordmustbechanged;
                        l.memberID = r.data.data.memberID;

                        // Reset the captchaValid so the user has to check the captcha on the change password view
                        l.captchaValid = false;
                        // utility.setCookie('SLID',resp.data.slid); - no longer needed

						// Redirect user to reset password in modal if password has expired
                        if (l.passwordmustbechanged) {
					        l.frm.pword = '';
                        	l.frm.show = 'changepassword';
                        	l.processing = false;
                        	l.mainLabel = 'Password Expired';
                        	l.saveresp = resp;
                        } else {
                       		m.close( resp );
                        }

                        // if we are a subadmin logging back in to the wizard...
                        if(r.data.data.showintermediatelogin && $window.location.href.indexOf('=w.manageSignUp#') > -1){
                            // for now, just redirect, eventually we need to build out an account selection UI for the modal instead
                            $window.location.href = '/myaccount/resetadminid/1';
                        }
                    }
                });
        };

        /** method to register a user **/
        l.registerUser = function(){
            validateForm();

            if( l.hasErrors )
                return;

            l.message = '';
            var oldBtn = l.btnLabel;
            l.processing = true;
            l.btnLabel = 'Processing...';
            var data = {};
                data.email = l.frm.loginemail;
                data.password = l.frm.pword;
                data.firstname = l.frm.firstname;
                data.lastname = l.frm.lastname;
                data.companyname = l.frm.companyname;
                // Changed to true so all new accounts bypass verification restriction (new as of 2022)
                data.loginuser = true;
            svc.createMember( data )
                .then(function( response ){
                    var r = util.lowerCaseKeys( response );
                    if( !resultCheck( r.data ) ){
                        // return to the login form
                        oldBtn = 'Login';
                        l.showForm('login');
                        createMemberMessageHandler(r.data);
                    }
                    else {
                        if(  angular.isDefined(r.data.message) && r.data.message.toString() !== '' ){
                            // successful - but typically happens when email verification if needed
                            var messageTitleOverride = null;

                            if (r.data.success) {
                                messageTitleOverride = 'Account verification required';
                            }

                            createMemberMessageHandler(r.data, messageTitleOverride);

                            l.frm.pword = '';
                            l.frm.firstname = '';
                            l.frm.lastname = '';
                            l.showForm('login');
                            oldBtn = 'Login';
                        } else {
                            // all good, log the user into the system
                            if( angular.isDefined(r.data.data.memberid) && parseInt( r.data.data.memberid ) > 0 ){
                                var resp = {};
                                    resp.data = r.data.data;
                                    resp.status = 'loggedin';
                                // Call code to start LiveRamp ATS
                                $window.startAts(r.data.data.email);
                                m.close( resp );
                            }
                            else {
                                util.showMagnificAlert('An unknown error occurred. If this error persists, please contact support.');
                            }
                        }
                    }
                    l.btnLabel = oldBtn;
                    l.processing = false;
                });
        };

        /** method to verify blacklisted address **/
        l.verifyAddress = function(){
            if( l.frm.verifytype === 'new' ){
                validateForm();
                if( l.hasErrors )
                    return;
            }

            l.message = '';
            var oldBtn = l.btnLabel;
            l.processing = true;
            l.btnLabel = 'Processing...';
            var data = {};
                data.email = l.frm.newemail;
                data.previousEmail = l.frm.loginemail;
            svc.verifyDisabledAccount( data )
                .then(function( response ){
                    var r = util.lowerCaseKeys( response );
                    if( !resultCheck( r.data ) ){
                        errorHandler( r.data );
                    }
                    else {
                        l.complete = true;
                        l.message = r.data.message;
                    }
                    l.processing = false;
                    l.btnLabel = oldBtn;
                });

        };

        var originalFbButtonLabel = angular.copy(l.fbBtnLabel);
        var setProcessing = function(processing){
            if(processing){
                l.processing = true;
                l.fbBtnLabel = 'Processing...';
                l.fbLoading = true;
            } else {
                l.processing = false;
                l.fbBtnLabel = originalFbButtonLabel;
                l.fbLoading = false;
            }
        };

        /** facebook login implementation **/
        l.loginFBUser = function(){
            var fbAuthInfo = {};
            var fbUserInfo = {};
            l.fbAuth = true;
            l.message = '';
            setProcessing(true);
            fbSvc.fbLogin()
                .then( function(response){
                    var r = util.lowerCaseKeys( response );
                    if( r.status === 'connected' && angular.isDefined(r.authresponse) && angular.isDefined(r.authresponse.accesstoken) ){
                        fbAuthInfo = r.authresponse;
                        return fbSvc.getFBUserInfo( fbAuthInfo );
                    } else {
                        // did not authenticate
                        setProcessing(false);
                    }
                },function(err){
                    // rejected
                    setProcessing(false);
                })
                .then( function(userinfo){
                    if( angular.isDefined(userinfo) ){
                        var result = util.lowerCaseKeys( userinfo ).data;
                        var failed = false;
                        if( !result.success ){
                            util.showMagnificAlert(result.message.toString());
                            failed = true;
                            setProcessing(false);
                        } else {
                            fbUserInfo = result.data;
                            if( !angular.isDefined(fbUserInfo.email) || !fbUserInfo.email.toString().length ){
                                util.showMagnificAlert('Invalid or missing email address. Your email address is required to log into your SignUpGenius account using Facebook.');
                                failed = true;
                                setProcessing(false);
                            } else {
                                var data = {};
                                    data.type = 'fb';
                                    data.email = fbUserInfo.email;
                                    data.firstname = fbUserInfo.first_name || '';
                                    data.lastname = fbUserInfo.last_name || '';
                                    data.userid = fbUserInfo.id;
                                    data.authToken = fbAuthInfo.accesstoken;
    								if( l.frm.remember )
    									data.remember = l.frm.remember;
                                return svc.loginUser( data );
                            }
                        }
                        if( failed ){
                            l.fbAuth = false;
                        }
                    }
                })
                .then( function( user ){
                    if( angular.isDefined(user) ){
                        var r = util.lowerCaseKeys( user );
                        if( !resultCheck( r.data ) ){
                            setProcessing(false);
                            var d = 'data' in r.data ? r.data.data : {};
                            if( angular.isDefined(d.isblacklisted) && d.isblacklisted ){
                                l.blacklistedAddress = fbUserInfo.email;
                                l.frm.loginemail = fbUserInfo.email;
                                l.frm.pword = '';
                                l.showForm( 'blacklisted' );
                            } else {
                                errorHandler( r.data );
                            }
                        } else {
                            // all good, log the user into the system
                            if( angular.isDefined(r.data.data.memberid) && parseInt( r.data.data.memberid ) > 0 ){
                                var resp = {};
                                    resp.data = r.data.data;
                                    resp.status = 'loggedin';
                                m.close( resp );
                            }
                            else {
                                util.showMagnificAlert('An unknown error occurred. If this error persists, please contact support.');
                                setProcessing(false);
                            }
                        }
                        l.fbAuth = false;
                        setProcessing(false);
                    }
                });
        };

        l.frmDisabled = function(){
            return l.fbAuth;
        };

        l.errorExists = function( elem ){
            return (elem in l.errorMessages );
        };

        l.getError = function( elem ){
            return (elem in l.errorMessages ) ? l.errorMessages[elem] : '';
        };

        l.close = function(){
            m.dismiss();
        };

        var validateForm = function( ){
            l.passwordErrors = {};
            l.errorMessages = {};
            l.hasErrors = false;
            var errorMessages = {
                "loginemail"  : "You must enter a valid email address.",
                "pword"     : "You must enter a password.",
                "pword2"     : "You must confirm the password.",
                "firstname" : "You must enter a first name.",
                "lastname"  : "You must enter a last name.",
                "newemail"  : "You must enter a valid email address.",
                "passwordInvalid" : "The password you entered does not meet our password criteria.",
                "passwordMatch" : "The passwords do not match.",
                "companyname" : "You must enter a company name."
            };

            var fields = ['loginemail','pword'];
            var pword = '';
            var pwordLenError = [];
            var pwordminlen = 0;

            var key = '';
            if ( l.frm.show === 'register' ) {
                fields = ['firstname','lastname','loginemail','pword'];
                if( l.requirecompany ){ fields.push('companyname'); }  //if company name is required check for it too
                pword = fields[3]; //ensures we use the same key
                valdiatePasswordStrength();
            } else if( l.frm.show === 'forgotpassword' ) {
                fields = ['loginemail'];
                if (!commonRegExService.emailRegEx().test(l.frm.loginemail)) {
                    l.errorMessages.loginemail = errorMessages.loginemail;
                }
            } else if( l.frm.show === 'blacklisted' && l.frm.verifytype == 'new' ) {
                fields = ['newemail'];
            } else if ( l.frm.show === 'changepassword') {
            	fields = ['pword','pword2'];
            	valdiatePasswordStrength();
            	if ( l.frm.pword && l.frm.pword2 && l.frm.pword !== l.frm.pword2 ) {
            		l.errorMessages.passwordMatch = errorMessages.passwordMatch;
            		l.hasErrors = true;
            	}
            };


            angular.forEach( fields, function(obj,key){
                if( !angular.isDefined( l.frm[obj] ) || typeof l.frm[obj] === undefined || !l.frm[obj].toString().length ){
                    l.errorMessages[obj] = errorMessages[obj];
                    l.hasErrors = true;
                }
            });


            if( ( (l.frm.show === 'forgotpassword' || l.frm.show === 'register') && !l.captchaValid) || (l.frm.show === 'login' && l.showrecaptcha && !l.captchaValid) ){
                util.showMagnificAlert('Invalid captcha response.');
                l.hasErrors = true;
            }

        };

        var validateRecaptcha = function (){
            if (!l.captchaValid) {
                util.showMagnificAlert('Invalid captcha response.');
                l.hasErrors = true;
            }
        }

        var resultCheck = function( response ){
			var result = util.lowerCaseKeys( response );
            try {
			    return (angular.isDefined(result.success) && result.success && angular.isDefined(result.data));
            } catch( e ){
                return false;
            }
		};

        var errorHandler = function( response ){
			var errMessage = svc.resultErrorHandler( response );
			util.showMagnificAlert(errMessage);
		};

        var createMemberMessageHandler = function (response, messageTitleOverride) {
            var overriddenTitle =  messageTitleOverride || null;
            var heading = overriddenTitle;
			var errMessage = svc.resultErrorHandler( response );
            var alertType = response.success ? 'success' : 'error';
            if (!heading) {
                if (response && response.data && response.data.messagetitle) {
                    heading = response.data.messagetitle;
                } else {
                    heading = response.success ? 'Success' : 'Error';
                }
            }

			util.showMagnificAlert(errMessage, alertType, '', heading);            
        };

        // check if we're loading the registration page first
        if( angular.isDefined(register) && register )
            l.showForm('register');

        // captcha callback
        recaptchaCallback = function( resp ){
            util.validateCaptcha( resp )
                .then( function(response){
                    var r = util.lowerCaseKeys( response );
                    if( !resultCheck( r.data ) ){
                        l.captchaValid = false;
                    }
                    else {
                        l.captchaValid = r.data.data;
                    }

                });
        };

        // Hack to fix weird iOS input cursor positioning bug
        l.iosPositioningFix = function(e){
            var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
            if(iOS){
                window.scrollTo(0,0);
                angular.element(e.target).focus();
            }
        };


		var valdiatePasswordStrength = function() {
			var payload = { "password": l.frm.pword };
			svc.validatePasswordRules(payload)
				.then( function(response){
					var r = util.lowerCaseKeys( response );
					var passwordValidation = r.data;

 					if (!passwordValidation.success) {
                        l.passwordErrorIsString = typeof(passwordValidation.message) == 'string' ? true : false;
						l.passwordErrors = passwordValidation.message;
						l.errorMessages.passwordInvalid = "The password you entered does not meet our password criteria.";
						l.hasErrors = true;
					}
				});
		}

		/** method to change user password **/
		l.changepassword = function() {
            validateForm();
            validateRecaptcha();

			$timeout(function() {
				if (!l.hasErrors) {
					var payload = { "ID": l.saveresp.data.memberid, "pword": l.frm.pword };
					svc.changePassword(payload)
						.then( function(response){
							var r = util.lowerCaseKeys( response );
							var changePassword = r.data;
							if (!changePassword.success) {
								l.hasErrors = true;
								l.errorMessages = changePassword.message;
							} else {
								m.close( l.saveresp );
							}
						});
				}
			}, 2000);
        }

        /** Parse URL vars to determine if Company Name is part of Registration */
        var params = utility.getAllUrlParams();
        l.showcompany = typeof params.showcompany !== 'undefined' ? !!+params.showcompany : !!+0;
        l.requirecompany = typeof params.requirecompany !== 'undefined' && l.showcompany ? !!+params.requirecompany : !!+0;
        l.isoptional = l.requirecompany ? '' : ' (optional)';

    }]);

})();
